import React, { Component } from "react";
import { connect } from "react-redux";
import { getSliderWithProducts } from "../../store/actions/slider";
import { recentlyAddedProducts } from "../../store/actions/product";
import PageTitle from "../../components/shared/PageTitle";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import CartWidget from "../../components/shared/CartWidget";
import SEO from "../../components/shared/SEO";
import VibrantProductCard from "../../components/VibrantProductCard";
import Loading from "../../components/shared/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { trackViewItemList } from "../../utils/analytics";

class SliderProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      sortBy: "default",
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    if (id) {
      this.props.getSliderWithProducts(id);
    }
    // İlgini çekebilecek ürünler için son eklenenleri getir
    if (
      !this.props.product.recentlyAddedProducts ||
      this.props.product.recentlyAddedProducts.length === 0
    ) {
      this.props.recentlyAddedProducts();
    }
  }

  componentDidUpdate(prevProps) {
    const { id } = this.props.match.params;
    if (id !== prevProps.match.params.id) {
      this.setState({ searchTerm: "", sortBy: "default" });
      this.props.getSliderWithProducts(id);
    }

    // Ürünler yüklendiğinde analytics list görünümü
    const prevCollection = prevProps.slider.sliderCollection;
    const collection = this.props.slider.sliderCollection;
    if (
      (!prevCollection && collection && collection.products) ||
      (prevCollection &&
        collection &&
        prevCollection.id !== collection.id &&
        collection.products)
    ) {
      if (collection.products.length > 0) {
        const listName =
          collection.title && collection.title.text
            ? collection.title.text
            : "Slider";
        trackViewItemList(collection.products, `Slider: ${listName}`);
      }
    }
  }

  getFilteredAndSortedProducts = () => {
    const collection = this.props.slider.sliderCollection;
    const products = collection ? collection.products : null;
    const { searchTerm, sortBy } = this.state;

    if (!products || products.length === 0) {
      return [];
    }

    let filtered = [...products];

    if (searchTerm) {
      filtered = filtered.filter(
        (product) =>
          product.name &&
          product.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    switch (sortBy) {
      case "featured":
        filtered = filtered.filter((product) => product.featured);
        break;
      case "deals":
        filtered = filtered.filter((product) => product.isDeal);
        break;
      case "new":
        filtered = filtered.filter((product) => {
          if (product.isNewProduct) return true;
          if (product.created_at) {
            const now = new Date();
            const createdDate = new Date(product.created_at);
            const daysDifference = (now - createdDate) / (1000 * 60 * 60 * 24);
            return daysDifference <= 7;
          }
          return false;
        });
        break;
      case "discounted":
        filtered = filtered.filter(
          (product) => product.sale_price && product.sale_price < product.price
        );
        break;
      case "price_asc":
        filtered.sort((a, b) => {
          const priceA = a.sale_price || a.price || 0;
          const priceB = b.sale_price || b.price || 0;
          return priceA - priceB;
        });
        break;
      case "price_desc":
        filtered.sort((a, b) => {
          const priceA = a.sale_price || a.price || 0;
          const priceB = b.sale_price || b.price || 0;
          return priceB - priceA;
        });
        break;
      default:
        break;
    }

    return filtered;
  };

  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  handleSortChange = (sortBy) => {
    this.setState({ sortBy });
  };

  getButtonStyle = (activeSort) => ({
    backgroundColor: this.state.sortBy === activeSort ? "#88c000" : "white",
    color: this.state.sortBy === activeSort ? "white" : "#666",
    border:
      this.state.sortBy === activeSort ? "1px solid #88c000" : "1px solid #ddd",
    borderRadius: "20px",
    padding: "6px 12px",
    fontSize: "12px",
    fontWeight: "500",
    transition: "all 0.3s ease",
    minWidth: "auto",
    whiteSpace: "nowrap",
    marginRight: "4px",
    marginBottom: "6px",
  });

  handleButtonHover = (e, activeSort, isEntering) => {
    if (this.state.sortBy !== activeSort) {
      if (isEntering) {
        e.target.style.backgroundColor = "#f0f8e8";
        e.target.style.borderColor = "#88c000";
        e.target.style.color = "#88c000";
      } else {
        e.target.style.backgroundColor = "white";
        e.target.style.borderColor = "#ddd";
        e.target.style.color = "#666";
      }
    }
  };

  render() {
    const { setting } = this.props;
    const { searchTerm, sortBy } = this.state;

    const isFetching = this.props.slider.sliderCollectionFetching;
    const collection = this.props.slider.sliderCollection;
    // Başlık önceliği: admin'de girilen collectionTitle > slider başlığı > varsayılan
    const collectionTitle =
      collection && collection.collectionTitle
        ? collection.collectionTitle
        : collection && collection.title && collection.title.text
        ? collection.title.text
        : "Slider Ürünleri";

    const displayProducts = this.getFilteredAndSortedProducts();
    const totalProducts =
      collection && collection.products ? collection.products.length : 0;

    const siteTitle =
      setting && setting.setting && setting.setting.title
        ? setting.setting.title
        : "Botaniksan";

    const pageSEO = {
      title: collectionTitle,
      description: `${siteTitle} — ${collectionTitle}`,
      type: "website",
      url: `/slider/${
        (collection && collection.slug) || this.props.match.params.id
      }`,
    };

    // İlgini çekebilecek ürünler: son eklenenlerden, slider'da zaten olanları çıkar
    const collectionProductIds = {};
    if (collection && collection.products) {
      collection.products.forEach((p) => {
        collectionProductIds[p.id] = true;
      });
    }
    const relatedProducts = (
      this.props.product.recentlyAddedProducts || []
    )
      .filter((p) => !collectionProductIds[p.id])
      .slice(0, 8);

    return (
      <React.Fragment>
        <SEO {...pageSEO} />
        <PageTitle title={collectionTitle} />

        <div
          className="container-fluid"
          style={{ paddingLeft: "15px", paddingRight: "15px" }}
        >
          {/* Başlık + Kontroller */}
          <div className="row" style={{ marginTop: 20 }}>
            <div className="col-12">
              <div
                style={{
                  background: "linear-gradient(135deg, #f0f8e8 0%, #fff 100%)",
                  border: "1px solid #e0e0e0",
                  borderRadius: "12px",
                  padding: "20px 15px",
                  marginBottom: 10,
                }}
              >
                <div className="row" style={{ marginBottom: 10 }}>
                  <div className="col-12">
                    <h1
                      style={{
                        fontSize: "20px",
                        fontWeight: 700,
                        color: "#333",
                        margin: 0,
                      }}
                    >
                      <FontAwesomeIcon
                        icon={["fas", "images"]}
                        style={{ color: "#88c000", marginRight: 8 }}
                      />
                      {collectionTitle}
                    </h1>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-4 col-md-5 col-sm-12 mb-3">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span
                          className="input-group-text"
                          style={{
                            backgroundColor: "#88c000",
                            color: "white",
                            border: "none",
                          }}
                        >
                          <FontAwesomeIcon icon={["fas", "filter"]} />
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Ürünlerde filtrele"
                        value={searchTerm}
                        onChange={this.handleSearchChange}
                        style={{
                          border: "1px solid #88c000",
                          borderLeft: "none",
                          fontSize: "14px",
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-7 col-sm-12">
                    <div className="d-flex flex-wrap align-items-center justify-content-lg-end">
                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("featured")}
                        style={this.getButtonStyle("featured")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "featured", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "featured", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "star"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Öne çıkan
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("deals")}
                        style={this.getButtonStyle("deals")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "deals", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "deals", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "bolt"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Fırsat Ürünü
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("new")}
                        style={this.getButtonStyle("new")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "new", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "new", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "tag"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Yeni ürün
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("discounted")}
                        style={this.getButtonStyle("discounted")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "discounted", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "discounted", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "percent"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        İndirimli ürünler
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("price_asc")}
                        style={this.getButtonStyle("price_asc")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "price_asc", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "price_asc", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "sort-amount-up"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Fiyat artan
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("price_desc")}
                        style={this.getButtonStyle("price_desc")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "price_desc", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "price_desc", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "sort-amount-down"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Fiyat azalan
                      </button>

                      {(searchTerm || sortBy !== "default") && (
                        <button
                          className="btn btn-sm"
                          onClick={() => {
                            this.setState({
                              searchTerm: "",
                              sortBy: "default",
                            });
                          }}
                          style={{
                            backgroundColor: "#ff6b6b",
                            color: "white",
                            border: "1px solid #ff6b6b",
                            borderRadius: "20px",
                            padding: "6px 12px",
                            fontSize: "12px",
                            fontWeight: "500",
                            transition: "all 0.3s ease",
                            minWidth: "auto",
                            whiteSpace: "nowrap",
                            marginRight: "4px",
                            marginBottom: "6px",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#ff5252";
                            e.target.style.borderColor = "#ff5252";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#ff6b6b";
                            e.target.style.borderColor = "#ff6b6b";
                          }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", "times"]}
                            style={{ marginRight: "5px", fontSize: "11px" }}
                          />
                          Temizle
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Ana içerik + Sidebar */}
          <div className="row">
            <div className="col-md-3">
              <CartWidget />
              <CategoriesWidget />
            </div>

            <div className="col-md-9">
              <div className="row">
                {isFetching ? (
                  <div className="col-12 text-center py-5">
                    <Loading />
                  </div>
                ) : displayProducts.length > 0 ? (
                  displayProducts.map((product, i) => (
                    <div
                      className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4"
                      key={product._id || product.id || i}
                    >
                      <VibrantProductCard
                        {...product}
                        listIndex={i}
                        listName={`Slider: ${collectionTitle}`}
                      />
                    </div>
                  ))
                ) : (
                  <div className="col-12 text-center py-5">
                    <div className="alert alert-info">
                      <h5>Ürün Bulunamadı</h5>
                      <p>
                        Bu slider için gösterilecek ürün bulunmuyor
                        {searchTerm || sortBy !== "default"
                          ? " (filtreleri değiştirmeyi deneyin)"
                          : ""}
                        .
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {!isFetching && displayProducts.length > 0 && (
                <div className="row mt-4">
                  <div className="col-12">
                    <div className="alert alert-light text-center">
                      <strong>{displayProducts.length}</strong> ürün
                      gösteriliyor
                      {totalProducts !== displayProducts.length && (
                        <span> (toplam {totalProducts} ürün içinden)</span>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* İlgini çekebilecek ürünler — slider ürünlerinin hemen altında, aynı sütun hizasında */}
              {relatedProducts.length > 0 && (
                <div className="mt-4" style={{ paddingTop: 10 }}>
                  <h2
                    style={{
                      fontSize: "20px",
                      fontWeight: 700,
                      color: "#333",
                      marginBottom: 18,
                      borderTop: "1px solid #eee",
                      paddingTop: 24,
                    }}
                  >
                    <FontAwesomeIcon
                      icon={["fas", "burn"]}
                      style={{ color: "#88c000", marginRight: 8 }}
                    />
                    İlgini Çekebilecek Ürünler
                  </h2>
                  <div className="row">
                    {relatedProducts.map((product, i) => (
                      <div
                        className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4"
                        key={product.id || i}
                      >
                        <VibrantProductCard
                          {...product}
                          listName="İlgini Çekebilecek Ürünler"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ slider, setting, category, product }) => {
  return { slider, setting, category, product };
};

const mapDispatchToProps = { getSliderWithProducts, recentlyAddedProducts };

export default connect(mapStateToProps, mapDispatchToProps)(SliderProducts);



// WEBPACK FOOTER //
// ./src/routers/SliderProducts/index.js